import { RuleTypeLabelPipe } from '../pipes/RuleTypeLabelPipe';
import * as _ from 'lodash';

export const RuleTypeEnum = Object.freeze({
    BASIC_ID_NEW_PLAYER: 'BASIC_ID_NEW_PLAYER',
    DEPOSIT_REQUIRES_PEP_AND_SANCTION: 'DEPOSIT_REQUIRES_PEP_AND_SANCTION',
    DEPOSIT_LIMIT_WITHOUT_BASIC_INFO: 'DEPOSIT_LIMIT_WITHOUT_BASIC_INFO',
    DEPOSIT_LIMIT_WITHIN_GRACEPERIOD_WITHOUT_ALL_CHECKS:
        'DEPOSIT_LIMIT_WITHIN_GRACEPERIOD_WITHOUT_ALL_CHECKS',
    HIGH_RISK_DEPOSIT_WITHOUT_ALL_CHECKS:
        'HIGH_RISK_DEPOSIT_WITHOUT_ALL_CHECKS',
    TOO_MANY_DEPOSITS_IN_SHORT_PERIOD: 'TOO_MANY_DEPOSITS_IN_SHORT_PERIOD',
    CONTINUOUS_ACTIVITY_IN_PERIOD: 'CONTINUOUS_ACTIVITY_IN_PERIOD',
    CHASING_LOSSES: 'CHASING_LOSSES',
    NEGATIVE_INTERACTION: 'NEGATIVE_INTERACTION',
    ASK_FOR_OFFERS_X_TIMES_IN_PERIOD: 'ASK_FOR_OFFERS_X_TIMES_IN_PERIOD',
    TOTAL_DEPOSITS_PLAYER_LIFETIME: 'TOTAL_DEPOSITS_PLAYER_LIFETIME',
    TOTAL_WITHDRAWALS_PLAYER_LIFETIME: 'TOTAL_WITHDRAWALS_PLAYER_LIFETIME',
    EXPIRED_DOCUMENTATION: 'EXPIRED_DOCUMENTATION'
});

export const makeRuleTypeDropdownOptions = () =>
    _.map(RuleTypeEnum, (value, key) => ({
        label: RuleTypeLabelPipe(key),
        value
    }));
